import Swiper, { Navigation}  from "swiper";

Swiper.use([Navigation]);
import gsap from "gsap";

/**
 * ValuesSlider class
 */
export default class ValuesSlider {
    constructor() {
        /**
         *
         * @type {{slider: string, pagination: string, progressBar: string, sliders: string}}
         */
        this.defaults = {
            //elements
            sliders: ".js-values-slider-wrapper",
            progressBar: ".js-progress-bar",
            slider: ".js-slider",
            pagination: ".js-slider-pagination",
        };
    }

    //region methods
    /**
     * ValuesSlider class init method and init flag
     */
    init() {
        console.log("ValuesSlider init()");

        const sliders = document.querySelectorAll(this.defaults.sliders);

        if (sliders.length > 0) {
            this.sliderController(sliders);
        }
    }

    /**
     *
     * @param {NodeListOf} sliders
     */
    sliderController(sliders) {
        sliders.forEach((sliderWrapper) => {
            const slider = sliderWrapper.querySelector(this.defaults.slider);
            const progressBar = sliderWrapper.querySelector(this.defaults.progressBar);

            const swiper = new Swiper(slider, {
                speed: 400,
                shortSwipes: true,
                slidesPerView: 1,
                effect: "fade",
                fadeEffect: {
                    crossFade: false,
                },
                pagination: {
                    el: sliderWrapper.querySelector(this.defaults.pagination),
                    clickable: true,
                    renderBullet: function (index, className) {
                        const title = this.slides[index].dataset.slideTitle;
                        const i = index < 9 ? `0${index + 1}` : index + 1;
                        return `<p class="u-a2 c-values-slider__bullet ${className}"><span>${i}</span>${title}</p>`;
                    },
                },
                breakpoints: {
                    600: {
                        shortSwipes: false,
                    },
                },
            });

            this.startCountdown(swiper, progressBar);

            swiper.on("slideChange", () => {
                this.startCountdown(swiper, progressBar);
            });
        });
    }

    /**
     *
     * Method will countdown to next slide then slider will trigger it again (it repeates infinitely)
     *
     * @param {swiper} swiper
     * @param {HTMLElement | Element} progressBar
     */
    startCountdown(swiper, progressBar) {
        gsap.killTweensOf(progressBar);
        gsap.fromTo(
            progressBar,
            {
                x: "-100%",
            },
            {
                x: "0%",
                duration: 15,
                ease: "none",
                onComplete: () => {
                    if (swiper.activeIndex === swiper.slides.length - 1) {
                        swiper.slideTo(0);
                    } else {
                        swiper.slideNext();
                    }
                },
            },
        );
    }

    //endregion
}
